import {action} from 'easy-peasy';
import merge from 'deepmerge';
import {overwriteMerge} from 'utils/deep-merge';

export default {
  loggedIn: localStorage.getItem('refreshToken') !== null,
  selfInfo: null,

  login: action((state) => {
    state.loggedIn = true;
  }),

  logout: action((state) => {
    state.loggedIn = false;
    state.selfInfo = null;
  }),

  setSelfInfo: action((state, payload) => {
    state.selfInfo = payload;
  }),

  updateSelfInfo: action((state, payload) => {
    if (state.selfInfo) {
      state.selfInfo = merge(state.selfInfo, payload, {
        arrayMerge: overwriteMerge,
      });
    }
  }),
};
